/* EVD Find A Gym v2 — fetch live gyms with aggressive image extraction + CORS proxy fallback */
(function(){
  var ENDPOINT = 'https://api.wtfup.me/website/gyms?is_website=1';
  var TOKEN = '34e18651f6e43cf352b48a3fe36a243fc07d9f9c1841ca6a42095e2166d5b4ed';
  var CORS_PROXIES = [
    'https://corsproxy.io/?',
    'https://api.allorigins.win/raw?url='
  ];

  function escapeHtml(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

  function statusClass(s){
    var t = (s||'').toLowerCase();
    if(t.indexOf('exclusive') >= 0) return 'excl';
    if(t.indexOf('plus') >= 0) return 'plus';
    return 'open';
  }

  function deepFindImage(node, depth){
    if(node == null || depth > 4) return '';
    if(typeof node === 'string'){
      var s = node.trim();
      if(/^https?:\/\//.test(s) && /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(s)) return s;
      if(/^https?:\/\/.*\/(image|photo|cover|banner|thumb|media|upload|gym)/i.test(s)) return s;
      return '';
    }
    if(Array.isArray(node)){
      for(var i=0;i<node.length;i++){
        var r = deepFindImage(node[i], depth+1);
        if(r) return r;
      }
      return '';
    }
    if(typeof node === 'object'){
      var prefer = ['image','image_url','imageUrl','cover_image','coverImage','cover','thumbnail','thumb','banner','banner_image','photo','featured_image','gym_image','main_image','hero_image','url','src'];
      for(var p=0;p<prefer.length;p++){
        if(node[prefer[p]]){
          var r2 = deepFindImage(node[prefer[p]], depth+1);
          if(r2) return r2;
        }
      }
      var arrFields = ['images','photos','gallery','media','pictures'];
      for(var a=0;a<arrFields.length;a++){
        if(node[arrFields[a]]){
          var r3 = deepFindImage(node[arrFields[a]], depth+1);
          if(r3) return r3;
        }
      }
      for(var k in node){
        if(/image|photo|cover|banner|thumb|picture|media|url|src/i.test(k)){
          var r4 = deepFindImage(node[k], depth+1);
          if(r4) return r4;
        }
      }
    }
    return '';
  }

  function cardHTML(g){
    var img = deepFindImage(g, 0);
    var title = escapeHtml(g.title || g.name || g.gym_name || g.display_name || 'WTF Gym');
    var loc = escapeHtml(g.location || g.area || g.city || g.address || g.locality || '');
    var status = escapeHtml(g.status || g.gym_type || (g.is_exclusive || g.exclusive ? 'WTF Exclusive' : 'Open Now'));
    var distance = escapeHtml(g.distance || g.dist || '');
    var rating = escapeHtml(g.rating || g.avg_rating || '4.7');
    var reviews = escapeHtml(g.reviews || g.review_count || g.reviews_count || '150');
    var hours = escapeHtml(g.hours || g.timing || (g.is_24x7 || g.is_24_7 ? '24x7 Open' : 'Open Now'));
    var url = g.url || g.link || g.detail_url || (g.slug ? ('/gyms/' + g.slug) : '#');
    var sc = statusClass(status);
    return '<article class="efg-card">'+
      '<div class="efg-card__img">'+
        (img ? '<img src="'+escapeHtml(img)+'" alt="'+title+'" loading="lazy" onerror="this.style.display=\'none\'">' : '')+
        '<span class="efg-card__status efg-card__status--'+sc+'">'+status+'</span>'+
        (distance ? '<span class="efg-card__dist">'+distance+'</span>' : '')+
      '</div>'+
      '<div class="efg-card__body">'+
        '<h3 class="efg-card__title">'+title+'</h3>'+
        '<div class="efg-card__loc">'+loc+'</div>'+
        '<div class="efg-card__meta">'+
          '<span class="efg-card__rating"><svg viewBox="0 0 24 24" fill="#FFC107"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>'+rating+' <span>('+reviews+')</span></span>'+
          '<span class="efg-card__hours"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>'+hours+'</span>'+
        '</div>'+
        '<div class="efg-card__tags"><span><i class="d d-red"></i>Strength</span><span><i class="d d-blue"></i>Cardio</span><span><i class="d d-orange"></i>PT</span></div>'+
        '<div class="efg-card__actions">'+
          '<a class="efg-card__cta" href="'+escapeHtml(url)+'">View Details <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="12" height="12"><path d="m9 6 6 6-6 6"/></svg></a>'+
          '<button class="efg-card__save" aria-label="Save"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg></button>'+
        '</div>'+
      '</div>'+
    '</article>';
  }

  function tryFetch(url, useToken){
    var opts = useToken ? { headers: { 'Authorization': 'Bearer ' + TOKEN, 'Accept': 'application/json' } } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); });
  }

  function fetchGyms(){
    return tryFetch(ENDPOINT, true).catch(function(){
      return tryFetch(CORS_PROXIES[0] + encodeURIComponent(ENDPOINT), false).catch(function(){
        return tryFetch(CORS_PROXIES[1] + encodeURIComponent(ENDPOINT), false);
      });
    });
  }

  function loadGyms(){
    var grid = document.querySelector('[data-efg-grid]');
    if(!grid) return;
    fetchGyms().then(function(data){
      var arr = [];
      if(Array.isArray(data)) arr = data;
      else if(data && Array.isArray(data.data)) arr = data.data;
      else if(data && Array.isArray(data.gyms)) arr = data.gyms;
      else if(data && Array.isArray(data.result)) arr = data.result;
      else if(data && Array.isArray(data.results)) arr = data.results;
      else if(data && data.data && Array.isArray(data.data.gyms)) arr = data.data.gyms;
      if(arr.length === 0) return;
      var html = arr.slice(0, 12).map(cardHTML).join('');
      grid.innerHTML = html;
      grid.setAttribute('data-efg-live', '1');
    }).catch(function(err){
      if(window.console && console.log) console.log('[evd-find-gym] API unavailable, keeping seed cards:', err && err.message);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', loadGyms);
  } else {
    loadGyms();
  }
})();
